import type {
  WorkoutExerciseRecord,
  WorkoutRecord,
  WorkoutSetValueRecord,
  WorkoutSupersetRecord,
} from '~/powersync/generated/schema';

/**
 * Input for creating a new workout
 * Omits auto-generated fields (id, timestamps, deletedAt)
 */
export type CreateWorkoutInput = Omit<
  WorkoutRecord,
  | 'id'
  | 'createdAt'
  | 'updatedAt'
  | 'deletedAt'
  | 'startedAt'
  | 'finishedAt'
  | 'niceId'
  | 'clonedFromId'
>;

/**
 * Input for updating an existing workout
 * Makes all fields optional except system fields
 */
export type UpdateWorkoutInput = Partial<
  Omit<WorkoutRecord, 'id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'userId'>
>;

/**
 * Workout with additional computed fields
 */
export interface WorkoutWithExerciseCount extends WorkoutRecord {
  exerciseCount: number;
}

/**
 * Input for creating a new workout exercise
 */
export type CreateWorkoutExerciseInput = Omit<
  WorkoutExerciseRecord,
  'id' | 'createdAt' | 'updatedAt' | 'deletedAt'
>;

/**
 * Input for updating an existing workout exercise
 * Makes editable fields optional except system fields
 */
export type UpdateWorkoutExerciseInput = Partial<
  Omit<
    WorkoutExerciseRecord,
    'id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'workoutId' | 'supersetId'
  >
>;

/**
 * Input for creating/updating a workout set value
 */
export type UpsertWorkoutSetValueInput = Omit<
  WorkoutSetValueRecord,
  'id' | 'createdAt' | 'updatedAt'
>;

/**
 * Input for updating a workout set value
 */
export type UpdateWorkoutSetValueInput = {
  value: number;
};

/**
 * Input for creating a new workout superset
 */
export type CreateWorkoutSupersetInput = Omit<
  WorkoutSupersetRecord,
  'id' | 'createdAt' | 'updatedAt' | 'deletedAt'
>;
